import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/gift-flow")({
  component: lazyRouteComponent(() => import("./-pages/admin.gift-flow")),
  head: () => ({ meta: [{ title: "Gift Flow Texts — Admin" }] }),
});
